import React, { useEffect, useState } from 'react';
import { getCookie, getSession } from "../utils/utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
function DatosUsuario() {

	const [userInfo, setUserInfo] = useState({
		id: "",
		correo: "",
		nombre_encargado: "",
		nombre_empresa: "",
		tipo_acceso: ""
	});

	const [editMode, setEditMode] = useState(false);
	const [originalUserInfo, setOriginalUserInfo] = useState({});
	const navigate = useNavigate();

	async function getInfo() {
		try {
			let session = await getSession();

			if (session === null) {
				navigate("/");
				return;
			}

			// console.log(session, "session");

			let uri = process.env.REACT_APP_API_URL + 'admin/usuarios/' + session.id;

			let config = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'Accept': 'application/json',
				}
			};

			if (Cookies.get("AuthToken")) {
				config.headers['Authorization'] = `Bearer ${Cookies.get("AuthToken")}`;
			}

			let response = await axios.get(uri, config); // Cambia el nombre de la variable para evitar confusiones
			// console.log(response, "userInfooooooo");
			setUserInfo({
				id: response.data.data.id,
				correo: response.data.data.correo,
				nombre_encargado: response.data.data.nombre_encargado,
				nombre_empresa: response.data.data.nombre_empresa,
				tipo_acceso: response.data.data.tipo_acceso
			});

			setOriginalUserInfo({
				id: response.data.data.id,
				correo: response.data.data.correo,
				nombre_encargado: response.data.data.nombre_encargado,
				nombre_empresa: response.data.data.nombre_empresa,
				tipo_acceso: response.data.data.tipo_acceso
			}); // Guardar la información original
		} catch (error) {
			console.log(error);
			if (error.response.status === 401) {
				navigate("/");
			}
		}	
	}

	useEffect(() => {
		getInfo();
	}, []);

	const handleEditToggle = () => {
		if (editMode) {
			// Si estamos saliendo del modo de edición, restaurar los valores originales
			setUserInfo(originalUserInfo);
		}
		setEditMode(!editMode);
	};

	const handleInputChange = (e, field) => {
		setUserInfo({
			...userInfo,
			[field]: e.target.value
		});
	};

	const handleSave = async () => {

		let session = await getSession();

		if (session === null) {
			navigate("/");
			return;
		}

		if (userInfo.email === "" || userInfo.name === "" || userInfo.company === "") {
			Swal.fire(
				{
					title: '¡Atención!',
					text: 'Por favor, complete todos los campos',
					icon: 'warning',
					confirmButtonText: 'Aceptar'
				}
			)
			return;
		}

		try {
			let uri = process.env.REACT_APP_API_URL + 'admin/usuarios/' + session.id;

			let config = {
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}
			};

			if (Cookies.get("AuthToken")) {
				config.headers['Authorization'] = `Bearer ${Cookies.get("AuthToken")}`;
			}

			let response = await axios({
				method: 'PUT',
				url: uri,
				data: {
					email: userInfo.correo,
					nombre_encargado: userInfo.nombre_encargado,
					nombre_empresa: userInfo.nombre_empresa,
					tipo_acceso: userInfo.tipo_acceso
				},
				headers: config.headers
			});
			// console.log(response);
			Swal.fire(
				{
					title: '¡Éxito!',
					text: 'Datos actualizados correctamente',
					icon: 'success',
					confirmButtonText: 'Aceptar'
				}
			)
				.then(function () {
					getInfo();
				})
		} catch (error) {
			console.log(error);
			if (error.response.status === 401) {
				navigate("/");
			}
		}
	};

	return (
		<div className="mt-10 px-6 w-full">
			<div className="w-full flex justify-center mb-5">
				<FontAwesomeIcon icon={faCircleUser} className="text-[#0E7FA0] text-4xl md:text-8xl rounded-full bg-white border w-[170px] h-[170px]" />
			</div>
			<div className='flex mb-4 p-2 justify-center text-center border-2 rounded-2xl'>
				<h1 className="text-[#0D7F9F] font-semibold pr-2">Acceso</h1>
				<p>{userInfo.tipo_acceso}</p>
			</div>
			<div className='flex flex-col justify-center border-2 p-4 rounded-xl w-full'>
				<div className='flex flex-wrap'>
					<div className='w-full md:w-1/2 px-2'>
						<h1 className="text-[#0D7F9F] items-center font-semibold">Nombre completo</h1>
						{editMode ? (
							<input
								type="text"
								className="w-full border-2 p-4 text-lg h-2/3 bg-[#D1ECF2] rounded-lg font-normal"
								value={userInfo.nombre_encargado}
								onChange={(e) => handleInputChange(e, 'nombre_encargado')}
							/>
						) : (
							<div>{userInfo.nombre_encargado}</div>
						)}
					</div>
					<div className='w-full md:w-1/2 px-2'>
						<h1 className="text-[#0D7F9F] items-center font-semibold">Correo electrónico</h1>
						{editMode ? (
							<input
								type="text"
								className="w-full border-2 p-4 text-lg h-2/3 bg-[#D1ECF2] rounded-lg font-normal"
								value={userInfo.correo}
								onChange={(e) => handleInputChange(e, 'correo')}
							/>
						) : (
							<p>{userInfo.correo}</p>
						)}
					</div>
					<div className='w-full px-2'>
						<h1 className="text-[#0D7F9F] items-center font-semibold">{(userInfo.role === "Admin") ? "Nombre de la empresa" : "Nombre de la sucursal"}</h1>
						{editMode ? (
							<input
								type="text"
								className="w-full border-2 p-4 text-lg h-2/3 bg-[#D1ECF2] rounded-lg font-normal"
								value={userInfo.nombre_empresa}
								onChange={(e) => handleInputChange(e, 'nombre_empresa')}
							/>
						) : (
							<p>{userInfo.nombre_empresa}</p>
						)}
					</div>
				</div>
			</div>
			<div className="flex justify-center w-full">
				{editMode && (
					<button
						className="mt-4 p-2 bg-[#0D7F9F] text-white rounded-lg mr-2"
						onClick={handleSave}
					>
						Guardar
					</button>
				)}
				<button
					className={`mt-4 p-2 text-white rounded-lg ${editMode ? 'bg-[#FBC022]' : 'bg-[#0D7F9F]'}`}
					onClick={handleEditToggle}
				>
					{editMode ? 'Cancelar' : 'Editar'}
				</button>
			</div>
		</div>
	);
}

export default DatosUsuario;